import {GET, POST} from "./RequestsCore";

/**
 * Sends an API request to transform the provided html to a downloadable|printable PDF (parsing shortcodes if existing).
 * Use 'do_parse_shortcodes = false' as param to force to not parse shortcodes and use raw $html_content provided.
 *
 * @param html_content
 * @param params
 * @param file_name
 * @param downloadable
 * @param raw
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function htmlToPdf(html_content, params = [], file_name = 'pdf_file.pdf', downloadable = true, raw = false) {
    let mode = 'download';
    if (!downloadable) {
        mode = 'preview';
    }
    let raw_mode = '';
    if (raw === true) {
        raw_mode = '/raw'
    }

    let data = {
        html: html_content
    }
    for (let i in params) {
        data[i] = params[i];
    }

    let pdf_content = await POST('/api/pdf/' + mode + raw_mode, data);
    if (!!pdf_content && !!pdf_content.data) {
        return pdf_content.data;
    }

    return pdf_content;
}

/**
 * Used for the GET request to show PDF
 *
 * @param params
 * @param options
 * @param file_name
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getTemplatePreviewPdf(params, file_name = 'pdf_previsualizado.pdf') {
    // Options: highlight | raw | download
    let res = await GET('/api/expedient/' + params.expedient + '/template/' + params.template + '/pdf', params);

    if (!!res && !!res.data && !!res.data.data) {
        return res.data.data;
    } else if (!!res && !!res.data) {
        return res.data;
    } else if (!!res) {
        return res;
    }

    return null;
}

/**
 * Asks the API to transform the provided html to a downloadable PDF. This PARSES shortcodes.
 *
 * @param html_content
 * @param params
 * @param file_name
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function htmlToDownloadablePdf(html_content, params = [], file_name = 'pdf_descargado.pdf') {
    return htmlToPdf(html_content, params, file_name, true, false);
}

/**
 * Asks the API to transform the provided html to a downloadable PDF. This DOES NOT parse shortcodes.
 *
 * @param html_content
 * @param file_name
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function htmlToRawDownloadablePdf(html_content, file_name = 'pdf_descargado.pdf') {
    return htmlToPdf(html_content, [], file_name, false, true);
}

/**
 * Asks the API to transform teh provided html to a previewable PDF. This PARSES shortcodes.
 *
 * @param html_content
 * @param params
 * @param file_name
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function htmlToPreviewablePdf(html_content, params = [], file_name = 'pdf_previsualizado.pdf') {
    return htmlToPdf(html_content, params, file_name, false, false);
}

/**
 * Asks the API to transform teh provided html to a previewable PDF. This DOES NOT parse shortcodes.
 *
 * @param html_content
 * @param file_name
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function htmlToRawPreviewablePdf(html_content, file_name = 'pdf_previsualizado.pdf') {
    return htmlToPdf(html_content, [], file_name, false, true);
}
